/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ConfigService } from './../../../core/services/config.service';
import { EditModeService } from './../../../core/services/edit-mode.service';
import { LocoNote } from './../../model/loco-note.model';
import { NotesDetails } from './../../model/notes-details.model';
import { PopupService } from './../../../core/services/popup.service';
import { Tab } from './../../../core/model/tab.model';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'lms-notes-data',
  templateUrl: './lms-notes-data.component.html',
  styleUrls: ['./lms-notes-data.component.scss']
})
export class LmsNotesDataComponent implements OnInit {

  @Input() note: LocoNote;
  @Input() tab: Tab;
  @Input() index: string;
  @Input() tabIndex: number;
  updateResponse: NotesDetails;
  configdata: any;
  @Output() deleteNote: EventEmitter<string> = new EventEmitter<string>();
  @Output() isEditForAdd: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private editModeService: EditModeService, private popupService: PopupService, private configService: ConfigService, 
    public user: UserService) {
    this.configdata = this.configService.getConfigData();
  }

  ngOnInit() {
    if (this.note) {
      this.note.editedNoteText = this.note.noteText;
    }
  }

  /**
   * Sets the page in edit mode
   * @memberOf LmsNotesDataComponent
   */
  public editNote() {
    if (this.note) {
      this.note.editMode = 'Y';
      this.isEditForAdd.emit(false);
      this.tab.mode = 'edit';
      this.checkEditModeStatus();
      this.popupService.setPageMode('Edit');
      if (this.popupService.getSubmitBtnId() !== 'notesAddUpdateBtn') {
        this.popupService.setSubmitBtnId('noteDataSubmitButton');
      }
      setTimeout(() => {
        const noteTextBox = document.getElementById('editNoteTextBox' + this.index);
        if (noteTextBox) {
          noteTextBox.focus();
        }
      }, 100);
    }
  }

  updateSearchText(event) {
    if (event) {
      this.note.editedNoteText = event ? event.toUpperCase() : '';
    }
  }

  /**
   * @memberOf LmsNotesDataComponent
   */
  public deleteNoteData() {
    if (this.note) {
      this.note.isDeleted = 'Y';
    }
    this.deleteNote.emit('delete');

  }

  /**
   * @private
   * @memberOf LmsNotesDataComponent
   */
  private checkEditModeStatus() {
    if (this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' && this.tab.mode === 'edit') {
      const editModeStatus = {
        status: true,
        message: this.configdata.messages.editModePopUp
      };
      this.editModeService.setEditMode(editModeStatus);
    } else {
      const editModeStatus = {
        status: false,
        message: ''
      };
      this.editModeService.setEditMode(editModeStatus);
    }
  }
}
